module.exports = __webpack_public_path__ + "static/media/trainerBg.34de857b.jpg";